var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55827 4.5583C4.67546 4.44126 4.83431 4.37552 4.99994 4.37552C5.16556 4.37552 5.32442 4.44126 5.44161 4.5583L9.99994 9.11663L14.5583 4.5583C14.6155 4.49689 14.6845 4.44764 14.7612 4.41348C14.8378 4.37932 14.9206 4.36095 15.0045 4.35947C15.0884 4.35799 15.1718 4.37343 15.2496 4.40486C15.3274 4.4363 15.3981 4.48308 15.4575 4.54243C15.5168 4.60178 15.5636 4.67248 15.595 4.7503C15.6265 4.82812 15.6419 4.91148 15.6404 4.9954C15.639 5.07932 15.6206 5.16208 15.5864 5.23875C15.5523 5.31541 15.503 5.38441 15.4416 5.44163L10.8833 9.99997L15.4416 14.5583C15.503 14.6155 15.5523 14.6845 15.5864 14.7612C15.6206 14.8378 15.639 14.9206 15.6404 15.0045C15.6419 15.0884 15.6265 15.1718 15.595 15.2496C15.5636 15.3275 15.5168 15.3981 15.4575 15.4575C15.3981 15.5168 15.3274 15.5636 15.2496 15.5951C15.1718 15.6265 15.0884 15.6419 15.0045 15.6405C14.9206 15.639 14.8378 15.6206 14.7612 15.5864C14.6845 15.5523 14.6155 15.503 14.5583 15.4416L9.99994 10.8833L5.44161 15.4416C5.32313 15.552 5.16642 15.6121 5.0045 15.6093C4.84259 15.6064 4.6881 15.5408 4.57359 15.4263C4.45908 15.3118 4.39348 15.1573 4.39063 14.9954C4.38777 14.8335 4.44787 14.6768 4.55827 14.5583L9.11661 9.99997L4.55827 5.44163C4.44123 5.32444 4.37549 5.16559 4.37549 4.99997C4.37549 4.83434 4.44123 4.67549 4.55827 4.5583Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5afc01f8d3681c61205eb7907a4e556b.svg";
export { ForwardRef as ReactComponent };